import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, IconButton, styled } from '@mui/material'

export const StyledIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
}))

export const StyledIconButton = styled(IconButton)(({ theme }) => {
  // a11y: white focus ring on the dark header where the default blue ring fails 3:1 (SC 1.4.11)
  const onDarkRing = theme.mixins.focusRingOnDark.shadow
  return {
    width: theme.typography.pxToRem(36),
    height: theme.typography.pxToRem(36),
    borderRadius: '3px',

    [`${StyledIcon}`]: {
      color: theme.palette.grey[100],
    },

    ':hover, :focus-visible': {
      backgroundColor: theme.palette.grey[700],
      [`${StyledIcon}`]: {
        color: theme.palette.common.white,
      },
    },

    // a11y: ring on mouse + keyboard, matching the drag handle + toolbar rules; keyboard-only
    // would leave the inherited blue :focus ring on mouse, which fails 3:1 on this dark surface
    ':focus, :focus-visible': {
      ...onDarkRing,
      boxShadow: `${onDarkRing.boxShadow} !important`,
    },

    '&.active': {
      backgroundColor: theme.palette.blue[600],
      [`${StyledIcon}`]: {
        color: theme.palette.common.white,
      },
    },
  }
})

export const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  listStyle: 'none',
  margin: 0,
  padding: 0,

  '& li:empty': {
    display: 'none',
  },
}))
